// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f08e3725","453":"9d2224f1","455":"d67efba9","644":"464ff423"}[chunkId] + ".chunk.js";
};